module.exports = __webpack_public_path__ + "img/u21104.2c757470.png";